import { Controller } from "@hotwired/stimulus"
import { requestConfirm } from "../util"

export default class extends Controller {
  static targets = ["form"]
  static values = { usersCount: Number }

  confirmDelete(event) {
    event.preventDefault()

    this.requestConfirmAndSubmit(
      "confirm-delete-users",
      {
        title: `Delete ${this.usersCountValue} ambassador(s)`,
        text: "This action cannot be undone."
      }
    )
  }

  async requestConfirmAndSubmit(modal, data) {
    const confirmed = await requestConfirm({ modal, data })
    if (!confirmed) return

    this.submitFormAndClose()
  }

  submitFormAndClose() {
    this.formTarget.requestSubmit()
    this.element.dispatchEvent(new CustomEvent("drawer:close", { bubbles: true }))
    this.element.dispatchEvent(new CustomEvent("table-checkboxes:clear", { bubbles: true }))
  }
}
